import Vue from '_lib/_vue';
import App from './index.vue';

Vue.config.productionTip = false;

import WebpDirective from '_lib/plugin/webp-directive.js';
Vue.use(WebpDirective);

import HeyboxIcon from '_lib/plugin/heybox-icon.js';
Vue.use(HeyboxIcon);

import reportPlugin from '_lib/plugin/heybox-report.js';
Vue.use(reportPlugin);

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

import {
  HbLoading,
  HbListLoading,
  HbEmpty,
  HbModal,
  HbTabs,
  HbTabPane,
  HbButton,
} from '@heybox-components/heybox-ui';
Vue.use(HbListLoading);
Vue.use(HbLoading);
Vue.use(HbEmpty);
Vue.use(HbModal);
Vue.use(HbTabs);
Vue.use(HbTabPane);
Vue.use(HbButton);

new Vue({
  render: (h) => h(App),
}).$mount('#app');
